import { InviteUserState } from './definitions';
export class InviteUsersFactory
{
	public static build(): InviteUserState
	{
		return {
			pageHeading: '',
			bulkInvite: '',
			description: '',
			descriptionItems: [],
			downloadReport: '',
			download:
			{
				downloadButton: '',
				errorMessage: ''
			},
			sendInvite:
			{
				downloadButton: '',
				errorMessage: ''
			},
			cancel: '',
			externalLink: {
				label: '',
				url: ''
			},
			submit:
			{
				downloadButton: '',
				errorMessage: ''
			},
			link:
			{
				downloadButton: '',
				errorMessage: ''
			},
			messageDescription: '',
			messageTitle: '',
			uploadFile: {
				onLoadIcon: { iconPath: '', altText: '' },
				errorIcon: { iconPath: '', altText: '' },
				successIcon: { iconPath: '', altText: '' },
				dragDropLabel: '',
				progressLabel: '',
				orLabel: '',
				uploadButtons: {
					chooseFile: ''
				},
				success: {
					inviteSuccess: '',
					bulkMessage: ''
				}
			},
			responseMessage: '',
			addUserBulkUploadBtn: ''
		};
	}
}

